const aa_planid = $("#rtx_option_plans_dropdown option:contains(4 weeks)").attr(
  "value"
);

if (aa_planid) {
  $('.product-form.products-subscription input[name="selling_plan"]').val(
    aa_planid
  );
}

function aa_bodyobserver() {
  let labelinserted = false;
  let ariainserted = false;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.querySelector('#countrySelect') && !labelinserted) {
          setTimeout(() => {
            $('#countrySelect').after('<label for="countrySelect" class="hide">Select Your Country</label>');
          }, 100);
          
          labelinserted = true;
          
          // observer.disconnect();
        }

        if (node.nodeType === 1 && node.querySelector('.zest--width-full input') && !ariainserted) {
          node.querySelector('.zest--width-full input').setAttribute('aria-label', 'zest-button-input');
          
          ariainserted = true;
        }

        if (node.nodeType === 1 && node.querySelector('.pd-modal__content')) {
          if ($('.pd-modal__content .pd-modal__title').is(':empty') && !$('body').hasClass('template-product')) {
            $('.pd-modal__content .pd-modal__title').append('<span class="hide">Modal Heading</span>');
            $('.pd-modal__content .pd-modal__close').append('<span class="hide">Close Button</span>');
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

aa_bodyobserver();



// $('body').on('DOMNodeInserted', function(e) {
//   if (e.originalEvent.relatedNode.localName == 'zest-button' && e.target.localName == "input") {
//     e.target.setAttribute('aria-label', 'zest-button-input');
//   }

//   if (e.target.id == "zonos") {
//     setTimeout(function() {
//       $('#zonos #countrySelect').before('<label for="countrySelect" class="hide">Select Your Country</label>');
//     }, 500);
//   }
// });

// function waitForElement(selector, callback) {
//     const observer = new MutationObserver((mutations, observer) => {
//         const element = document.querySelector(selector);
//         if (element) {
//             observer.disconnect();
//             callback(element);
//         }
//     });

//     observer.observe(document.body, {
//         childList: true,
//         subtree: true,
//     });
// }

// waitForElement('body', (element) => {
//   if(element.querySelector('.zest--width-full').hasChildNodes()) {
//     console.log('okkkkkk')
//     element.querySelector('.zest--width-full input').setAttribute('aria-label', 'zest-button-input');
//   }
// });

// waitForElement('.zest--width-full', (element) => {
//   element.querySelector('input').setAttribute('aria-label', 'zest-button-input');
// });

// waitForElement('#zonos #countrySelect', (element) => {
//   element.insertAdjacentHTML('afterend', '<label for="countrySelect" class="hide aarif">Select Your Country</label>');
// });
